import juicePic from "../../../../images/juice.png";
export const juiceData = [
  {
    name: "Apple juice",
    image: juicePic,
    price: "40.00",
    description:
      "Fresh apple apple apple apple apple apple apple apple apple apple apple apple apple apple",
  },

  {
    name: "Beet juice",
    image: juicePic,
    price: "130.00",
    description: "Rotten beet",
  },
  {
    name: "Cantaloupe juice",
    price: "150.50",
    deletedprice: ".200",
    description: "cheese,Naga",
  },
  {
    name: "Corollar Juice",
    image: juicePic,
    price: "15.00",
    deletedprice: ".200",
    description: "cheese,Naga",
  },
  {
    name: "Mular Juice",
    image: juicePic,
    price: "15.00",
    deletedprice: ".20",
    description: "cheese,Naga",
  },
];
